import React, { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Select,
  MenuItem,
  Checkbox,
  FormControl,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import {
  useLazyDeleteTutorByIdQuery,
  useLazyGetAllTutorListingQuery,
  useLazyTutorCsvQuery,
  usePutTutorProfileMutation,
} from "../../services/tutor";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody } from "../../types/General";
import { successToast, errorToast } from "../../helpers";
import Loader from "../../helpers/Loader";
import WarnModal from "../../components/modals/WarnModal";
import Pagination from "../../components/Pagination";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validation";
import {
  useLazyDeleteByIdFormQuery,
  useLazyGetAllFormsQuery,
  useUpdateFormsMultiMutation,
  useUpdateFormsMutation,
} from "../../services/forum";
import {
  APP_ROLE,
  BULK_STATUS,
  CONTENT_TYPE,
  STATUS,
} from "../../helpers/constants/enums";
import { useGetTutorListQuery } from "../../services/class";

const Pending = () => {
  const [stateofTutor, setstateofTutor] = useState<{ [key: string]: number }>(
    {}
  );
  const [deleteById] = useLazyDeleteByIdFormQuery();
  const [updateTutorStatus] = usePutTutorProfileMutation();
  const [open, setOpen] = useState(false);
  const [updated] = useUpdateFormsMutation();
  const [updatedMulti] = useUpdateFormsMultiMutation();
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.ceil(totalCount / 10);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [allVideos] = useLazyGetAllFormsQuery();
  const navigate = useNavigate();
  const [rows, setRows] = useState<any>([
    {
      _id: "1",
      name: "John Doe",
      email: "john.doe@example.com",
      phoneNo: "9876543210",
      dialCode: "+91",
      image: "https://randomuser.me/api/portraits/men/11.jpg",
      tumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/0.jpg",
      subject: "English",
      topic: "Tenses",
      seats: 50,
      classType: "Online",
      classAvailability: "Private",
      promocode: "SAVE15",
      isBlocked: false,
    },
    {
      _id: "2",
      name: "Sophia Brown",
      email: "sophia.brown@example.com",
      phoneNo: "9812345678",
      dialCode: "+91",
      image: "https://randomuser.me/api/portraits/women/21.jpg",
      tumbnail: "https://img.youtube.com/vi/9bZkp7q19f0/0.jpg",
      subject: "Mathematics",
      topic: "Geometry",
      seats: 40,
      classType: "Offline",
      classAvailability: "Group",
      promocode: "MATH40",
      isBlocked: false,
    },
    {
      _id: "3",
      name: "Liam Smith",
      email: "liam.smith@example.com",
      phoneNo: "9823456789",
      dialCode: "+91",
      image: "https://randomuser.me/api/portraits/men/31.jpg",
      tumbnail: "https://img.youtube.com/vi/3JZ_D3ELwOQ/0.jpg",
      subject: "Science",
      topic: "Motion",
      seats: 35,
      classType: "Online",
      classAvailability: "Group",
      promocode: "SCI35",
      isBlocked: true,
    },
    {
      _id: "4",
      name: "Emma Wilson",
      email: "emma.wilson@example.com",
      phoneNo: "9934567890",
      dialCode: "+91",
      image: "https://randomuser.me/api/portraits/women/34.jpg",
      tumbnail: "https://img.youtube.com/vi/tAGnKpE4NCI/0.jpg",
      subject: "History",
      topic: "World War I",
      seats: 25,
      classType: "Offline",
      classAvailability: "Private",
      promocode: "HIST25",
      isBlocked: false,
    },
    {
      _id: "5",
      name: "Noah Johnson",
      email: "noah.johnson@example.com",
      phoneNo: "9945678901",
      dialCode: "+91",
      image: "https://randomuser.me/api/portraits/men/42.jpg",
      tumbnail: "https://img.youtube.com/vi/kXYiU_JCYtU/0.jpg",
      subject: "Computer Science",
      topic: "Programming Basics",
      seats: 60,
      classType: "Online",
      classAvailability: "Group",
      promocode: "CODE60",
      isBlocked: true,
    },
  ]);
  const [value, setValue] = useState<number>(1);
  const [tututorStatust, settututorStatust] = useState<number>(1);
  const [exportCsv] = useLazyTutorCsvQuery();
  // const [getAllTutorList, { isLoading }] = useLazyGetAllTutorListingQuery();
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTutor, setSelectedTutor] = useState("");
  const { data: tutorData } = useGetTutorListQuery();

  // const handleDeleteVideos = async (id: any) => {
  //   try {
  //     const response = await deleteById({ id }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Teasor video deleted successfully");
  //       fetchVideos();
  //     }
  //   } catch (error: any) {
  //     console.error(error);
  //     errorToast(error?.message || "");
  //   }
  // };

  const fetchVideos = async () => {
    try {
      setIsLoading(true);
      const response = await allVideos({
        page: page,
        search: debouncedSearchTerm,
        createdBy: APP_ROLE.TUTOR,
        contentType: CONTENT_TYPE.TEASER_VIDEO,
        status: STATUS.PENDING,
        ...(selectedTutor ? { userId: selectedTutor } : {}),
      }).unwrap();
      if (response.statusCode === 200) {
        setRows(response.data?.data);
        setTotalCount(response?.data?.total);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const changeStatus = async (id: any, status: any) => {
    try {
      const body = {
        status,
        type: BULK_STATUS.UPDATE,
        ids: [id],
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updatedMulti({ body: encryptedBody }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Teasor video status updated successfully");
        fetchVideos();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };

  const handleRowCheckboxClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    rowId: string
  ) => {
    if (event.target.checked) {
      setSelectedRows((prevSelected) => [...prevSelected, rowId]);
    } else {
      setSelectedRows((prevSelected) =>
        prevSelected.filter((id) => id !== rowId)
      );
    }
  };

  // const fetchApi = async (tutorId: string[], tutorStatus: boolean) => {
  //   try {
  //     const body = {
  //       ids: tutorId,
  //       status: "tutorUpdate",
  //       isBlocked: String(tutorStatus),
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor Account Status updated successfully");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };

  // const fetchRejectedTutor = async () => {
  //   try {
  //     const response = await getAllTutorList({
  //       page: page,
  //       search: searchTerm,
  //       tutorStatus: String(tututorStatust),
  //       isDelete: false,
  //     }).unwrap();
  //     if (response.statusCode === 200) {
  //       setRows(response.data?.tutor);
  //       setTotalCount(response?.data?.totalTutor);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const changeUserStatus = async (tutorIds: string[], tutorStatus: string) => {
  //   try {
  //     const body = {
  //       status: tutorStatus,
  //       ids: tutorIds,
  //     };
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

  //     const response = await updateTutorStatus({ encryptedBody }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor State updated successfully");
  //       fetchRejectedTutor();
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //     console.error(error);
  //   }
  // };

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  // const handleDeleteTutor = async (userId: any) => {
  //   try {
  //     const response = await deleteById({ userId }).unwrap();
  //     if (response?.statusCode === 200) {
  //       successToast("Tutor deleted successfully");
  //       fetchRejectedTutor();
  //     }
  //   } catch (error: any) {
  //     console.error(error);
  //     errorToast(error?.message || "");
  //   }
  // };

  // const handleExportCsv = async () => {
  //   try {
  //     const res = await exportCsv({ tutorStatus: 1 }).unwrap();
  //     const parsedRes = typeof res === "string" ? JSON.parse(res) : res;

  //     if (parsedRes && parsedRes.message && parsedRes.message.s3Location) {
  //       window.open(parsedRes.message.s3Location);
  //       successToast("Csv exported successfully");
  //     } else {
  //       errorToast("Error: s3Location not found in response");
  //     }
  //   } catch (error: any) {
  //     errorToast(error?.message);
  //   }
  // };
  const handleTutorChange = (event: any) => {
    setSelectedTutor(event.target.value);
  };

  const handleApprove = async () => {
    if (selectedRows.length === 0) {
      errorToast("Please select at least one row to approve.");
      return;
    }
    await changeContentStatus(selectedRows, BULK_STATUS.ACCEPT);
  };

  const handleReject = async () => {
    if (selectedRows.length === 0) {
      errorToast("Please select at least one row to reject.");
      return;
    }
    await changeContentStatus(selectedRows, BULK_STATUS.REJECT);
  };

  // useEffect(() => {
  //   fetchRejectedTutor();
  // }, [page, searchTerm, tututorStatust, value]);

  const changeContentStatus = async (id: any[], Status: any) => {
    if (Status == "") {
      return;
    }
    try {
      const body = {
        // status: Status == STATUS.APPROVED ? STATUS.APPROVED : STATUS.REJECTED,
        ids: id,
        type:
          Status === BULK_STATUS.ACCEPT
            ? BULK_STATUS.ACCEPT
            : BULK_STATUS.REJECT,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await updatedMulti({ body: encryptedBody }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Teasor Video State updated successfully");
        fetchVideos();
      }
    } catch (error: any) {
      errorToast(error?.message);
      console.error(error);
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    setSelectedRows(
      event.target.checked ? rows?.map((r: { _id: any }) => r._id) : []
    );
  };

  const handleDelete = async (id: any) => {
    try {
      const response = await deleteById({ id }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Video deleted successfully");
        fetchVideos();
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.message || "");
    }
  };

  useEffect(() => {
    fetchVideos();
  }, [page, debouncedSearchTerm, selectedTutor]);

  return (
    <div>
      <Loader isLoad={isLoading} />
      <Box className="cards_header">
        <SearchBar
          value={searchTerm}
          searchTerm={searchTerm}
          onCross={() => setSearchTerm("")}
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          onChange={(val: any) => {
            if (isValidInput(val.target.value)) {
              setSearchTerm(val.target.value);
            }
          }}
        />

        <Box className="cards_header_right">
          {/* <div style={{ display: "flex", marginBottom: "10px" }}> 
          {value === 1 && (*/}
          <>
            <FormControl fullWidth>
              <Select
                className="select_div"
                value={selectedTutor}
                displayEmpty
                // disabled={Boolean(_id)}
                onChange={handleTutorChange}
              >
                <MenuItem value="">Select Tutor</MenuItem>
                {tutorData?.data?.map((item: any) => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.userName} ({item.name})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className="btn btn_primary"
              style={{
                backgroundColor: "#008000",
                color: "#ffffff",
              }}
              onClick={handleApprove}
            >
              Accept
            </Button>
            <Button
              variant="contained"
              className="btn btn_primary"
              style={{
                backgroundColor: "black",
                color: "#ffffff",
              }}
              onClick={handleReject}
            >
              Reject
            </Button>
          </>
          {/*     )} 
         </div> */}
          {/* <Button
            className="btn btn_primary"
            // onClick={handleExportCsv}
          >
            <FileDownloadIcon /> Export CSV
          </Button>*/}

          {/* <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-videos/add")}
          >
            <AddIcon />
            Add Videos
          </Button> */}
        </Box>
      </Box>

      <TableContainer className="table_container">
        <Box className="heading"></Box>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all rows" }}
                />
              </TableCell>
              <TableCell align="center">S.No</TableCell>
              <TableCell align="center">Video</TableCell>
              <TableCell align="center">Image</TableCell>
              <TableCell align="center">Full Name</TableCell>
              <TableCell align="center">Contact Number</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Title</TableCell>
              <TableCell align="center">Topic</TableCell>
              <TableCell align="center">Request</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 ? (
              rows?.map((row: any, i: any) => (
                <TableRow key={row?._id}>
                  <TableCell>
                    <Checkbox
                      checked={selectedRows.includes(row._id)}
                      onChange={(event) =>
                        handleRowCheckboxClick(event, row._id)
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    {(page - 1) * 10 + i + 1}
                  </TableCell>
                  <TableCell>
                    <figure>
                      <video
                        style={{
                          width: 100,
                          height: 50,
                        }}
                        src={row?.images?.[0] || "static/images/logo.png"}
                        // alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    <figure
                      // onClick={() =>
                      //   navigate(`/manage-tutors/details/${row._id}`, {
                      //     state: { userStatus: "PENDING" },
                      //   })
                      // }
                      className="user_img"
                    >
                      <img
                        src={
                          row?.user?.image ||
                          "/static/images/user_placeholder.png"
                        }
                        alt=""
                      />
                    </figure>
                  </TableCell>
                  <TableCell>
                    {row?.user?.name ? row?.user?.name : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.user?.dialCode + row.user?.phoneNo}
                  </TableCell>
                  <TableCell>
                    {row?.user?.email ? row?.user?.email : "-"}
                  </TableCell>
                  <TableCell>{row.title ? row?.title : "-"}</TableCell>
                  <TableCell>{row.topic ? row?.topic : "-"}</TableCell>
                  <TableCell align="center">
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={""}
                      onChange={(e) => {
                        changeContentStatus([row?._id], e.target.value);
                      }}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Pending
                      </MenuItem>
                      <MenuItem value={BULK_STATUS.ACCEPT}>Approved</MenuItem>
                      <MenuItem value={BULK_STATUS.REJECT}>Rejected</MenuItem>
                    </Select>
                  </TableCell>
                  <TableCell>
                    <Switch
                      checked={row?.status}
                      onChange={(e) => {
                        changeStatus(row?._id, !row?.status);
                      }}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Box className="table_actions">
                      <IconButton
                        onClick={() =>
                          navigate(`/manage-videos/details/${row._id}`, {
                            state: { userStatus: "PENDING" },
                          })
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          navigate(`/manage-videos/edit/${row._id}`)
                        }
                      >
                        <ModeEditIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setOpen(true);
                          setSelectedId(row?._id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No video found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows}
          page={page}
          onPageChange={handleChangePage}
          totalPages={totalPages}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => {
          handleDelete(selectedId);
        }}
        // handleDelete={() => handleDeleteTutor(selectedId)}
        name="Teasor video"
      />
    </div>
  );
};

export default Pending;
